module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "todo-type-toggle"
  }, [_c('md-button', {
    staticClass: "md-raised md-primary",
    nativeOn: {
      "click": function($event) {
        _vm.isTodoSquare = !_vm.isTodoSquare
      }
    }
  }, [_vm._v(_vm._s(_vm.isTodoSquare ? '切换到列表' : '切换到四象限'))])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isTodoSquare),
      expression: "!isTodoSquare"
    }],
    staticClass: "todo-list-table"
  }, [_c('div', {
    staticClass: "todo-group"
  }, [_c('transition-group', {
    attrs: {
      "name": "todo-list",
      "mode": "out-in"
    }
  }, _vm._l((_vm.todoFilter), function(todo) {
    return _c('md-whiteframe', {
      key: todo.id,
      staticClass: "todo-item",
      attrs: {
        "md-elevation": "1"
      },
      nativeOn: {
        "mouseover": function($event) {
          _vm.selectedOne = todo.id
        },
        "mouseout": function($event) {
          _vm.selectedOne = ''
        }
      }
    }, [_c('div', {
      staticClass: "todo-content"
    }, [_c('md-checkbox', {
      attrs: {
        "id": "my-test1",
        "name": "my-test1"
      },
      on: {
        "change": function($event) {
          _vm.completeTodo(todo.id, todo.isCompleted)
        }
      },
      model: {
        value: (todo.isCompleted),
        callback: function($$v) {
          todo.isCompleted = $$v
        },
        expression: "todo.isCompleted"
      }
    }, [_vm._v(" " + _vm._s(todo.text))]), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "todo-icon"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.selectedOne == todo.id),
        expression: "selectedOne==todo.id"
      }],
      staticClass: "todo-control"
    }, [_c('md-icon', {
      staticClass: "todo-delete",
      nativeOn: {
        "click": function($event) {
          _vm.removeTodo(todo.id)
        }
      }
    }, [_vm._v("delete")]), _vm._v(" "), _c('span', {
      staticClass: "todo-to-tomato",
      on: {
        "click": function($event) {
          _vm.redirectToTomato(todo)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("../../assets/tomato.png")
      }
    })])], 1)])], 1)])
  }))], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isShowTodoInput),
      expression: "!isShowTodoInput"
    }],
    staticClass: "todo-add-tip tip-task",
    on: {
      "click": _vm.showTodoInput
    }
  }, [_c('md-icon', {
    staticClass: "md-accent"
  }, [_vm._v("add")]), _vm._v(" "), _c('span', [_vm._v("添加任务")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowTodoInput),
      expression: "isShowTodoInput"
    }],
    staticClass: "input-area"
  }, [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', [_c('md-input-container', [_c('md-input', {
    attrs: {
      "placeholder": "添加任务"
    },
    model: {
      value: (_vm.todoInputVal),
      callback: function($$v) {
        _vm.todoInputVal = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "todoInputVal"
    }
  })], 1), _vm._v(" "), _c('div', [_c('md-radio', {
    attrs: {
      "id": "level1",
      "name": "my-test-group1",
      "md-value": "1"
    },
    model: {
      value: (_vm.todoPriority),
      callback: function($$v) {
        _vm.todoPriority = $$v
      },
      expression: "todoPriority"
    }
  }, [_vm._v("紧急且重要")]), _vm._v(" "), _c('md-radio', {
    staticClass: "md-warn",
    attrs: {
      "name": "my-test-group1",
      "md-value": "2"
    },
    model: {
      value: (_vm.todoPriority),
      callback: function($$v) {
        _vm.todoPriority = $$v
      },
      expression: "todoPriority"
    }
  }, [_vm._v("重要但不紧急")]), _vm._v(" "), _c('md-radio', {
    staticClass: "md-primary",
    attrs: {
      "name": "my-test-group1",
      "md-value": "3"
    },
    model: {
      value: (_vm.todoPriority),
      callback: function($$v) {
        _vm.todoPriority = $$v
      },
      expression: "todoPriority"
    }
  }, [_vm._v("紧急但不重要")]), _vm._v(" "), _c('md-radio', {
    attrs: {
      "id": "level4",
      "name": "my-test-group1",
      "md-value": "4"
    },
    model: {
      value: (_vm.todoPriority),
      callback: function($$v) {
        _vm.todoPriority = $$v
      },
      expression: "todoPriority"
    }
  }, [_vm._v("不紧急且不重要")])], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('md-button', {
    staticClass: "md-icon-button md-raised md-primary add-btn",
    attrs: {
      "disabled": _vm.todoInputVal.length === 0
    },
    nativeOn: {
      "click": function($event) {
        _vm.addTodo($event)
      }
    }
  }, [_c('md-icon', [_vm._v("add")])], 1)], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isTodoSquare),
      expression: "isTodoSquare"
    }]
  }, [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-whiteframe', {
    staticClass: "todo-square todo-urgent-important ",
    attrs: {
      "md-elevation": "4"
    }
  }, [_c('md-whiteframe', {
    staticClass: "todo-square-title",
    attrs: {
      "md-elevation": "1"
    }
  }, [_c('md-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.squareType !== 'iAndU'),
      expression: "squareType!=='iAndU'"
    }],
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "90"
    }
  }, [_c('div', [_vm._v("紧急且重要")])]), _vm._v(" "), _c('md-layout', {
    nativeOn: {
      "click": function($event) {
        _vm.squareType = 'iAndU'
      }
    }
  }, [_c('md-icon', [_vm._v("add")])], 1)], 1), _vm._v(" "), _c('md-input-container', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.squareType === 'iAndU'),
      expression: "squareType==='iAndU'"
    }],
    staticClass: "square-add-todo"
  }, [_c('md-input', {
    attrs: {
      "placeholder": "输入完成按回车添加"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.addTodo(1)
      }
    },
    model: {
      value: (_vm.todoInputVal),
      callback: function($$v) {
        _vm.todoInputVal = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "todoInputVal"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "todo-square-list"
  }, _vm._l((_vm.urgentAndImportantTodos), function(todo) {
    return _c('div', {
      key: todo.id,
      staticClass: "todo-content"
    }, [_c('md-checkbox', {
      attrs: {
        "id": "my-test1",
        "name": "my-test1"
      },
      on: {
        "change": function($event) {
          _vm.completeTodo(todo.id, todo.isCompleted)
        }
      },
      model: {
        value: (todo.isCompleted),
        callback: function($$v) {
          todo.isCompleted = $$v
        },
        expression: "todo.isCompleted"
      }
    }, [_vm._v(" " + _vm._s(todo.text))]), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "todo-icon"
      }
    }, [_c('md-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.selectedOne == todo.id),
        expression: "selectedOne==todo.id"
      }],
      staticClass: "todo-delete",
      nativeOn: {
        "click": function($event) {
          _vm.removeTodo(todo.id)
        }
      }
    }, [_vm._v("delete")])], 1)], 1)
  }))], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-whiteframe', {
    staticClass: "todo-square todo-noturgent-important",
    attrs: {
      "md-elevation": "4"
    }
  }, [_c('md-whiteframe', {
    staticClass: "todo-square-title",
    attrs: {
      "md-elevation": "1"
    }
  }, [_c('md-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.squareType !== 'notIButU'),
      expression: "squareType!=='notIButU'"
    }],
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "90"
    }
  }, [_c('div', [_vm._v("紧急但不重要")])]), _vm._v(" "), _c('md-layout', {
    nativeOn: {
      "click": function($event) {
        _vm.squareType = 'notIButU'
      }
    }
  }, [_c('md-icon', [_vm._v("add")])], 1)], 1), _vm._v(" "), _c('md-input-container', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.squareType === 'notIButU'),
      expression: "squareType==='notIButU'"
    }],
    staticClass: "square-add-todo"
  }, [_c('md-input', {
    attrs: {
      "placeholder": "输入完成按回车添加"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.addTodo(2)
      }
    },
    model: {
      value: (_vm.todoInputVal),
      callback: function($$v) {
        _vm.todoInputVal = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "todoInputVal"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "todo-square-list"
  }, _vm._l((_vm.urgentAndNotImportantTodos), function(todo) {
    return _c('div', {
      key: todo.id,
      staticClass: "todo-content"
    }, [_c('md-checkbox', {
      attrs: {
        "id": "my-test1",
        "name": "my-test1"
      },
      on: {
        "change": function($event) {
          _vm.completeTodo(todo.id, todo.isCompleted)
        }
      },
      model: {
        value: (todo.isCompleted),
        callback: function($$v) {
          todo.isCompleted = $$v
        },
        expression: "todo.isCompleted"
      }
    }, [_vm._v(" " + _vm._s(todo.text))]), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "todo-icon"
      }
    }, [_c('md-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.selectedOne == todo.id),
        expression: "selectedOne==todo.id"
      }],
      staticClass: "todo-delete",
      nativeOn: {
        "click": function($event) {
          _vm.removeTodo(todo.id)
        }
      }
    }, [_vm._v("delete")])], 1)], 1)
  }))], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-whiteframe', {
    staticClass: "todo-square todo-urgent-notimportant",
    attrs: {
      "md-elevation": "4"
    }
  }, [_c('md-whiteframe', {
    staticClass: "todo-square-title",
    attrs: {
      "md-elevation": "1"
    }
  }, [_c('md-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.squareType !== 'IButNotU'),
      expression: "squareType!=='IButNotU'"
    }],
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "90"
    }
  }, [_c('div', [_vm._v("重要但不紧急")])]), _vm._v(" "), _c('md-layout', {
    nativeOn: {
      "click": function($event) {
        _vm.squareType = 'IButNotU'
      }
    }
  }, [_c('md-icon', [_vm._v("add")])], 1)], 1), _vm._v(" "), _c('md-input-container', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.squareType === 'IButNotU'),
      expression: "squareType==='IButNotU'"
    }],
    staticClass: "square-add-todo"
  }, [_c('md-input', {
    attrs: {
      "placeholder": "输入完成按回车添加"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.addTodo(3)
      }
    },
    model: {
      value: (_vm.todoInputVal),
      callback: function($$v) {
        _vm.todoInputVal = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "todoInputVal"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "todo-square-list"
  }, _vm._l((_vm.notUrgentAndImportantTodos), function(todo) {
    return _c('div', {
      key: todo.id,
      staticClass: "todo-content"
    }, [_c('md-checkbox', {
      attrs: {
        "id": "my-test1",
        "name": "my-test1"
      },
      on: {
        "change": function($event) {
          _vm.completeTodo(todo.id, todo.isCompleted)
        }
      },
      model: {
        value: (todo.isCompleted),
        callback: function($$v) {
          todo.isCompleted = $$v
        },
        expression: "todo.isCompleted"
      }
    }, [_vm._v(" " + _vm._s(todo.text))]), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "todo-icon"
      }
    }, [_c('md-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.selectedOne == todo.id),
        expression: "selectedOne==todo.id"
      }],
      staticClass: "todo-delete",
      nativeOn: {
        "click": function($event) {
          _vm.removeTodo(todo.id)
        }
      }
    }, [_vm._v("delete")])], 1)], 1)
  }))], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-whiteframe', {
    staticClass: "todo-square todo-noturgent-notimportant",
    attrs: {
      "md-elevation": "4"
    }
  }, [_c('md-whiteframe', {
    staticClass: "todo-square-title",
    attrs: {
      "md-elevation": "1"
    }
  }, [_c('md-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.squareType !== 'notIAndNotU'),
      expression: "squareType!=='notIAndNotU'"
    }],
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "90"
    }
  }, [_c('div', [_vm._v("不紧急且不重要")])]), _vm._v(" "), _c('md-layout', {
    nativeOn: {
      "click": function($event) {
        _vm.squareType = 'notIAndNotU'
      }
    }
  }, [_c('md-icon', [_vm._v("add")])], 1)], 1), _vm._v(" "), _c('md-input-container', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.squareType === 'notIAndNotU'),
      expression: "squareType==='notIAndNotU'"
    }],
    staticClass: "square-add-todo"
  }, [_c('md-input', {
    attrs: {
      "placeholder": "输入完成按回车添加"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.addTodo(4)
      }
    },
    model: {
      value: (_vm.todoInputVal),
      callback: function($$v) {
        _vm.todoInputVal = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "todoInputVal"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "todo-square-list"
  }, _vm._l((_vm.notUrgentAndNotImportantTodos), function(todo) {
    return _c('div', {
      key: todo.id,
      staticClass: "todo-content"
    }, [_c('md-checkbox', {
      attrs: {
        "id": "my-test1",
        "name": "my-test1"
      },
      on: {
        "change": function($event) {
          _vm.completeTodo(todo.id, todo.isCompleted)
        }
      },
      model: {
        value: (todo.isCompleted),
        callback: function($$v) {
          todo.isCompleted = $$v
        },
        expression: "todo.isCompleted"
      }
    }, [_vm._v(" " + _vm._s(todo.text))]), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "todo-icon"
      }
    }, [_c('md-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.selectedOne == todo.id),
        expression: "selectedOne==todo.id"
      }],
      staticClass: "todo-delete",
      nativeOn: {
        "click": function($event) {
          _vm.removeTodo(todo.id)
        }
      }
    }, [_vm._v("delete")])], 1)], 1)
  }))], 1)], 1)], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "todo-header"
  }, [_c('span', {
    staticClass: "todo-header-day"
  }, [_vm._v("今天")]), _vm._v(" "), _c('span', {
    staticClass: "todo-header-date"
  }, [_vm._v("星期六 5月6日")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/.11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-92b9c378"}!./~/.11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/plugins/Todo.vue
// module id = 354
// module chunks = 1